<template>
	<form v-if="true" id="change-password-form" novalidate class="needs-validation" v-on:submit.prevent="saveForm">
		<error :error="error"></error>

		<div class="form-row">
			<div class="col-sm-6">
				<div class="m-t pl-3 form-group required">
					<label class="control-label required font-weight-bold" for="password-input">Password</label>
					<input ref="passwordInput" id="password-input" class="form-control" type="password" placeholder="password" 
						v-model="password"/>
				</div>
			</div>
			<div class="col-sm-6">
				<div class="m-t form-group required">
					<label class="control-label required font-weight-bold" for="confirm-input">Confirm Password</label>
					<input id="confirm-input" class="form-control" type="password" placeholder="confirm" v-model="confirm"/>
				</div>
			</div>
		</div>

		<div class="clearfix mt-3 mb-3">
			<div class="float-right mr-3">
				<button type="submit" class="btn btn-outline-primary px-3">Update</button>
				<button type="button" class="btn btn-outline-primary px-3" @click="closeForm">Cancel</button>
			</div>
		</div>
	</form>	
	
</template>

<script>
	import Error from './Error'

	import api from '../api'
	import store from '../state'

	export default {
		name: 'ChangePasswordForm',
		components: {Error},
		data() {
			return {
				password: '',
				confirm: '',
				error: null
			}
		},
		methods: {
			closeForm() {
				this.$emit('close-change-password');
			},
			async saveForm() {
				
				try
				{
					var response = await api.put('token/user/password', {password:this.password, confirm:this.confirm});	
					this.closeForm();
				}
				catch(err) {
					this.error = err;
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/ChangePasswordForm.vue